import styled from '@emotion/styled';
import { ActionButton } from 'components/shared/actionButton';

export const StyledActionButton = styled(ActionButton)(() => ({
  width: '72px',
}));
